import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled }, "@mui/material/Box": Box, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemAvatar": ListItemAvatar, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/material/Avatar": Avatar, "@mui/material/IconButton": IconButton, "@mui/material/FormGroup": FormGroup, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Checkbox": Checkbox, "@mui/material/Grid": Grid, "@mui/material/Typography": Typography, "@mui/icons-material/Folder": FolderIcon, "@mui/icons-material/Delete": DeleteIcon } } });
export default ClientProvider;
